import { useTableStore } from '../../../../state/';
import { handleRequestSort } from '../../utils/helpers';

export const createSortHandler = (property: any) => (event: any) => {
    const setPagination = useTableStore((state: { setPagination: any; }) => state.setPagination)
    const pagination = useTableStore(state => state.pagination)
    const { order, orderBy } = pagination

    console.log(`sort date createSortHandler property ${property} e }`, event.target.checked)
    if (event.target.checked !== true && event.target.checked !== false) {
        handleRequestSort(event, property, setPagination, pagination, orderBy, order);
    }
};